// src/pages/CalculoHonorarios/components/DetalheCalculo.js

import React, { useState } from 'react';
import SecaoResultado from './SecaoResultado';

const DetalheCalculo = ({ 
  honorario, 
  calculo, 
  onRecalcular, 
  onGerarEmail, 
  onVoltar,
  calculando,
  gerandoEmail
}) => {
  const [alteracoesCalculo, setAlteracoesCalculo] = useState('');
  const [mostrarAlteracoesCalculo, setMostrarAlteracoesCalculo] = useState(false);
  
  const [alteracoesEmail, setAlteracoesEmail] = useState('');
  const [mostrarAlteracoesEmail, setMostrarAlteracoesEmail] = useState(false);

  if (!honorario) return null;

  const totalHoras = parseFloat(honorario.base_total_horas) || 0;
  const valorHora = parseFloat(honorario.base_valor_hora) || 0;
  const valorBase = totalHoras * valorHora;

  const resolverNomeCliente = () => {
    if (honorario.nome_cli) return honorario.nome_cli;
    if (honorario.cod_cli) return `Código: ${honorario.cod_cli}`;
    return 'Não especificado';
  };

  const handleRecalcular = () => {
    if (!alteracoesCalculo.trim()) {
      if (!window.confirm('Nenhuma alteração foi especificada. Deseja recalcular mesmo assim?')) {
        return;
      }
    }
    
    onRecalcular(alteracoesCalculo);
    setAlteracoesCalculo('');
    setMostrarAlteracoesCalculo(false);
  };

  const handleGerarEmail = (comAlteracoes = false) => {
    if (comAlteracoes) {
      if (!alteracoesEmail.trim()) {
        if (!window.confirm('Nenhuma alteração foi especificada. Deseja gerar email mesmo assim?')) {
          return;
        }
      }
      onGerarEmail(alteracoesEmail);
      setAlteracoesEmail('');
      setMostrarAlteracoesEmail(false);
    } else {
      onGerarEmail();
    }
  };

  return (
    <div className="detalhe-calculo">
      <div className="detalhe-header">
        <button className="btn-voltar" onClick={onVoltar}>
          ← Voltar
        </button>
        <h2>💰 Cálculo de Honorários</h2>
      </div>

      {/* Cabeçalho com dados básicos */}
      <div className="calculo-info-basica">
        <div className="info-row">
          <div className="info-item">
            <label>Cliente:</label>
            <span>{resolverNomeCliente()}</span>
          </div>
          <div className="info-item">
            <label>Data Criação:</label>
            <span>{new Date(honorario.created_at).toLocaleDateString('pt-PT')}</span>
          </div>
        </div>

        <div className="info-row">
          <div className="info-item">
            <label>Total de Horas:</label>
            <span>{totalHoras}h</span>
          </div>
          <div className="info-item">
            <label>Valor/Hora:</label>
            <span>{valorHora.toFixed(2)} €</span>
          </div>
          <div className="info-item valor-base-destaque">
            <label>Valor Base:</label>
            <span>{valorBase.toFixed(2)} €</span>
          </div>
        </div>
      </div>

      {/* Resultados dos cálculos */}
      {calculo ? (
        <div className="calculo-resultados">
          {/* CÁLCULO */}
          <SecaoResultado 
            titulo="Cálculo de Honorários"
            icone="💰"
            conteudo={calculo.calculo}
            colapsavel={true}
          />

          {/* RACIONAL */}
          <SecaoResultado 
            titulo="Racional (Justificativa)"
            icone="📝"
            conteudo={calculo.racional}
            colapsavel={true}
          />

          {/* AÇÕES DO CÁLCULO */}
          <div className="calculo-acoes-secao">
            {!mostrarAlteracoesCalculo ? (
              <button 
                className="action-btn secondary-btn"
                onClick={() => setMostrarAlteracoesCalculo(true)}
                disabled={calculando || gerandoEmail}
              >
                ✏️ ALTERAR INSTRUÇÕES (Recalcular)
              </button>
            ) : (
              <div className="alteracoes-box">
                <h4>✏️ Alterar Instruções para Recálculo</h4>
                <p className="alteracoes-hint">
                  Estas alterações vão modificar o cálculo de honorários (LLM1 + LLM2)
                </p>
                <textarea
                  value={alteracoesCalculo}
                  onChange={(e) => setAlteracoesCalculo(e.target.value)}
                  placeholder="Descreva as alterações que deseja fazer no cálculo...
Exemplo: 
- Reduzir o valor em 10%
- Considerar que o cliente é de baixa renda
- Ajustar urgência para alta"
                  className="form-textarea"
                  rows="5"
                />
                <div className="alteracoes-acoes">
                  <button 
                    className="action-btn primary-btn"
                    onClick={handleRecalcular}
                    disabled={calculando}
                  >
                    {calculando ? '⏳ Recalculando...' : '🔄 RE-CALCULAR'}
                  </button>
                  <button 
                    className="action-btn cancel-btn"
                    onClick={() => {
                      setMostrarAlteracoesCalculo(false);
                      setAlteracoesCalculo('');
                    }}
                    disabled={calculando}
                  >
                    ❌ CANCELAR
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* TEXTO EMAIL */}
          {calculo.email ? (
            <>
              <SecaoResultado 
                titulo="Texto para Email/Proposta"
                icone="📧"
                conteudo={calculo.email}
                colapsavel={true}
              />

              {/* AÇÕES DO EMAIL */}
              <div className="calculo-acoes-secao">
                {!mostrarAlteracoesEmail ? (
                  <button 
                    className="action-btn secondary-btn"
                    onClick={() => setMostrarAlteracoesEmail(true)}
                    disabled={calculando || gerandoEmail}
                  >
                    ✏️ ALTERAR TEXTO EMAIL
                  </button>
                ) : (
                  <div className="alteracoes-box">
                    <h4>✏️ Alterar Texto do Email</h4>
                    <p className="alteracoes-hint">
                      Estas alterações vão modificar apenas o texto do email (LLM3)
                    </p>
                    <textarea
                      value={alteracoesEmail}
                      onChange={(e) => setAlteracoesEmail(e.target.value)}
                      placeholder="Descreva as alterações que deseja fazer no email...
Exemplo: 
- Tom mais formal
- Incluir informações sobre prazo de validade
- Mencionar experiência prévia com casos similares"
                      className="form-textarea"
                      rows="5"
                    />
                    <div className="alteracoes-acoes">
                      <button 
                        className="action-btn primary-btn"
                        onClick={() => handleGerarEmail(true)}
                        disabled={gerandoEmail}
                      >
                        {gerandoEmail ? '⏳ Gerando...' : '🔄 REGERAR EMAIL'}
                      </button>
                      <button 
                        className="action-btn cancel-btn"
                        onClick={() => {
                          setMostrarAlteracoesEmail(false);
                          setAlteracoesEmail('');
                        }}
                        disabled={gerandoEmail}
                      >
                        ❌ CANCELAR
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className="calculo-acoes-secao">
              <button 
                className="action-btn primary-btn"
                onClick={() => handleGerarEmail(false)}
                disabled={calculando || gerandoEmail}
              >
                {gerandoEmail ? '⏳ Gerando...' : '📧 GERAR TEXTO PROPOSTA'}
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className="sem-calculo">
          <p>⚠️ Nenhum cálculo realizado ainda.</p>
          <button 
            className="action-btn primary-btn"
            onClick={() => onRecalcular('')}
            disabled={calculando}
          >
            {calculando ? '⏳ Calculando...' : '🔢 CALCULAR HONORÁRIOS'}
          </button>
        </div>
      )}

      {calculando && (
        <div className="loading-overlay">
          <div className="loading-box">
            <div className="spinner"></div>
            <p>⏳ Calculando honorários...</p>
            <p className="loading-info">Este processo pode demorar até 2 minutos</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default DetalheCalculo;